import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { DeviceDetectorService } from 'ngx-device-detector';
import { ChangePasswordComponent } from 'src/app/auth/components/change-password/change-password.component';
import { LoginComponent } from 'src/app/auth/components/login/login.component';
import { IClient } from 'src/app/core/models';
import { BearerToken } from 'src/app/core/models/bearer.token';
import {
  AuthService,
  ClientService,
  IOutletFeaturesDto,
  IRestaurantDto,
  MenuService,
  OutletService,
  RestaurantService,
  ToastService,
  TokenService,
} from 'src/app/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'ic-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
  public clientConfig: IClient;
  // public initialized = false;
  public isLoggedIn = false;
  public isOutletSelected = false;
  public showMenu = false;
  public restaurantInfo: IRestaurantDto;
  public outletFeatures: IOutletFeaturesDto;
  public currentUser: BearerToken | any;
  public storeConfig = {
    showStore: true,
    isDesktop: true,
    isMobile: false,
    isAndroid: false,
  };

  constructor(
    private readonly clientService: ClientService,
    private readonly restaurantService: RestaurantService,
    private readonly authService: AuthService,
    private readonly tokenService: TokenService,
    private readonly router: Router,
    private readonly toastService: ToastService,
    private readonly deviceService: DeviceDetectorService,
    private readonly outletService: OutletService,
    private readonly menuService: MenuService,
    private readonly dialog: NgbModal
  ) {
    this.clientConfig = this.clientService.currentClientValue;
    this.storeConfig.isMobile = this.deviceService.isMobile();
    this.storeConfig.isDesktop = this.deviceService.isDesktop();
    this.router.events.subscribe((data) => {
      if (data instanceof NavigationEnd) {
        if (data.url !== '/home') {
          this.storeConfig.showStore = false;
        }
      }
    });
  }

  ngOnInit(): void {
    this.authService.isLoggedIn.subscribe((loggedIn) => {
      this.isLoggedIn = loggedIn;
      this.currentUser = this.tokenService.getToken();
    });

    const outletId = this.clientConfig?.outlet?.id;
    if (outletId) {
      this.isOutletSelected = true;
      this.getOutletFeatures();
    }

    this.clientService.isOutletSelected.subscribe((outletSelected) => {
      if (!outletSelected) {
        this.outletFeatures = null;
      }

      this.isOutletSelected = outletSelected;
      if (
        outletSelected &&
        (this.clientConfig?.outlet?.id ||
          this.clientService.selectedOutletValue)
      ) {
        this.getOutletFeatures();
      }
    });

    this.checkDeviceInfo();
    if (this.clientConfig?.active) {
      this.getRestaurantDetails();
    }
  }

  checkDeviceInfo() {
    const deviceInfo = this.deviceService.getDeviceInfo();
    this.storeConfig.isAndroid = deviceInfo.os.toLowerCase() !== 'ios';
  }

  updateClientDetails() {
    let client = this.clientService.getClient();
    if (this.restaurantInfo) {
      client.currency = this.restaurantInfo.currency;
      if (
        this.restaurantInfo.colorCode &&
        this.restaurantInfo.colorCode != ''
      ) {
        client.color = this.restaurantInfo.colorCode;
        client.style = {
          bgImage: this.restaurantInfo.backgroundImage,
          bg: {
            'background-color': this.restaurantInfo.colorCode,
          },
          color: { color: this.restaurantInfo.colorCode },
        };
      }
    } else {
      client.active = false;
    }
    this.clientService.setCurrentClient(client, false);
    this.clientConfig = this.clientService.currentClientValue;
    // this.initialized = true;
  }

  getRestaurantDetails() {
    this.restaurantService
      .getRestaurant(this.clientConfig.restaurantId)
      .subscribe(
        (data) => {
          this.restaurantInfo = data;
          this.updateClientDetails();
          if (!this.restaurantInfo) {
            this.toastService.showInfo('Inactive Restaurant');
            this.router.navigate(['not-found']);
            return;
          }

          if (this.restaurantInfo.notification.length > 0) {
            this.clientService.setNotification(
              this.restaurantInfo.notification[0]
            );
          }
        },
        (err) => {
          this.toastService.showError(err);
        }
      );
  }

  getOutletFeatures() {
    this.outletService
      .getOutletFeatures(
        this.clientService.selectedOutletValue || this.clientConfig?.outlet?.id
      )
      .subscribe(
        (data) => {
          this.outletFeatures = data;
          //this.outletFeatures.rewards = this.restaurantInfo?.isRewardPoints;
          this.clientService.setOutletFeatures(this.outletFeatures);
        },
        (err) => {
          this.toastService.showError(err.exceptionMessage || err.message);
        }
      );
  }

  updateOutletFeatures() {
    this.clientService.outletFeature.subscribe((features) => {
      this.outletFeatures = features;
    });
  }

  openLoginDialog() {
    if (this.restaurantInfo) {
      const modal = this.dialog.open(LoginComponent, {
        backdrop: 'static',
        windowClass: 'cstm_modal_Nmodal',
        ariaLabelledBy: 'login-modal-title',
        size: '',
      });
      const data = {
        isOtpLogin: this.restaurantInfo.isOtpLogin,
      };
      modal.componentInstance.dialogData = data;
    }
  }

  changePassword() {
    this.dialog.open(ChangePasswordComponent, {
      backdrop: 'static',
      windowClass: 'cstm_modal_Nmodal',
      ariaLabelledBy: 'change-password-modal-title',
      size: '',
    });
  }

  navigateCart() {
    if (!this.isOutletSelected) {
      return;
    }
    const cart = this.menuService.getCart();
    if (!cart || cart.length === 0) {
      this.toastService.showError('Please add items in the cart');
      return;
    }
    this.router.navigate(['/checkout']);
  }

  logOut() {
    this.authService.logOut();
    this.router.navigate(['/home']);
    this.toastService.showSuccess('You have been logged out successfully');
  }
}
